import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guard/auth.guard';
import { ForgotPasswordComponent } from './modules/auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './modules/auth/reset-password/reset-password.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./layouts/auth-layout/auth-layout.module').then(m => m.AuthLayoutModule),
  },
  {
    path: 'super-admin',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./layouts/admin-layout/admin-layout.module').then(m => m.AdminLayoutModule),
  },
  {
    path: 'developer',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./layouts/admin-layout/admin-layout.module').then(m => m.AdminLayoutModule),
  },
  {
    path: 'admin',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./layouts/admin-layout/admin-layout.module').then(m => m.AdminLayoutModule),
  },
  {
    path: 'provider',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./layouts/provider-layout/provider-layout.module').then(m => m.ProviderLayoutModule),
  },
  {
    path: 'sales-executive',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./layouts/admin-layout/admin-layout.module').then(m => m.AdminLayoutModule),
  },
  {
    path: 'guest',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./layouts/admin-layout/admin-layout.module').then(m => m.AdminLayoutModule),
  },
  // {
  //   path: 'service-engineer',
  //   canActivate: [AuthGuard],
  //   loadChildren: () =>
  //     import('./layouts/admin-layout/admin-layout.module').then(m => m.AdminLayoutModule),
  // },
  {
    path: 'forget-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
  },
  // {
  //   path: 'shared/machine/view/:id',
  //   canActivate: [AuthGuard],
  //   component: MachineViewDetailsComponent,
  // },
  {
    path: 'common',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./layouts/common-layout/common-layout.module').then(m => m.CommonLayoutModule),
  },
  {
    path: '**',
    loadChildren: () =>
      import('./shared/page-not-found/page-not-found.module').then(m => m.PageNotFoundModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
